import { createAction, props } from "@ngrx/store";

export const openPanel = createAction("[Sidebar] Open panel", props<{ panelName: string }>());
export const closePanel = createAction("[Sidebar] Close panel", props<{ panelName: string }>());
export const closeAllPanels = createAction("[Sidebar] Close all panels");
